import axios from "axios";

export const state = {
    donations: [],
};

export const getters = {
    donations: state => state.donations,
};

export const mutations = {
    setDonations(state, newValue) {
        state.donations = newValue
    },
};

export const actions = {
    async fetchDonations({ commit }) {
        await axios.get('/donations').then(res => {
            commit('setDonations', res.data.donations)
        })
    },
};